import { useGetSavedTalentFiltersQuery } from "@js/apps/freelancer/api";

export const useSavedTalentsFilters = () => {
  const { data: savedTalentFilters = [] } = useGetSavedTalentFiltersQuery();

  return {
    savedTalentFilters,
  };
};
